import React, { useContext, useState } from "react";
import PsContext from "../../../context";

const FooterButton = () => {
  const context = useContext(PsContext);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  return (
    <div>
      <a
        href="#"
        className="btn btn-lg back-to-top"
        style={{
          backgroundColor: `${context.settingValue("web_site_header_bgcolor")}`,
          color: isHovered
            ? context.settingValue("web_site_header_textcolor")
            : "white",
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <i className="fa fa-arrow-up text-black"></i>
      </a>
    </div>
  );
};

export default FooterButton;
